"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fastObjectShallowCompare", {
  enumerable: true,
  get: function () {
    return _fastObjectShallowCompare.fastObjectShallowCompare;
  }
});
var _fastObjectShallowCompare = require("./fastObjectShallowCompare");